export enum MUTATION_KEYS {
  ADMIN_ASSIGN_PROJECTS = "admin-assign-projects",
  UPDATE_ONBOARDING_PROGRESS = "update-onboarding-checklist-item",
  CREATE_RELEASE_TRACKS_FROM_PROJECTS = "create-release-tracks-from-projects",
}
